<template>
  <div v-if="$route.meta.layout === 'app-shell'" class="app-layout-shell">
    <AppSidebar />
    <div class="app-main-content">
      <router-view></router-view>
    </div>
  </div>
  <template v-else>
    <router-view></router-view>
  </template>
  <GlobalNotification />
  <ConflictBackupPanel />
</template>

<script>
import { onMounted } from "vue";
import { useAuthStore } from "@/store/authStore.js";
import AppSidebar from "@/components/AppSidebar.vue";
import GlobalNotification from "@/components/GlobalNotification.vue";
import ConflictBackupPanel from "@/components/ConflictBackupPanel.vue";

export default {
  name: "App",
  components: {
    AppSidebar,
    GlobalNotification,
    ConflictBackupPanel,
  },
  setup() {
    const authStore = useAuthStore();

    // アプリ起動時にユーザー情報を取得
    onMounted(async () => {
      if (authStore.token) {
        await authStore.fetchUser();
      }
    });

    return {};
  },
};
</script>

<style>
/* App.vueのスタイルはglobal.cssに移行済み */
</style>
